export const AUTH_PATHS = {
  SIGNIN: 'signin',
  SIGNUP: 'signup',
  VERIFY_DOMAIN: 'verify-domain',
  EMAIL_VERIFY: 'emailverify',
  THANK_YOU: 'thankyou',
}

export const KNOWLEDGEBASE_PATH = {
  PREFIX: 'knowledgebase',
  ARTICLES: 'articles',
  CATEGORIES: 'categories',
  CUSTOMIZATION: 'customization',
  GENERAL: 'general',
  ADVANCED: 'advance',
  SEO: 'seo',
  VERSION_CONTROL: 'version-control',
  BACKUP_AND_RESTORE: 'backup-and-restore',
  CUSTOM_CSS_JS: 'custom-css-js',
  REDIRECT_RULES: 'redirect-rules',
  IMPORT_EXPORT: 'import-export',
}

export const ASSETS_PATH = {
  PREFIX: 'assets',
  ALL: 'all',
  DEFAULT: 'default',
  FIELDS: 'fields',
  IMPORT: 'import',
}

export const CLIENT_PORTAL_PATH = {
  PREFIX: 'portal',
  ANNOUNCEMENTS: 'announcements',
  CUSTOMIZATION: 'customization',
  GENERAL: 'general',
  TICKETS: 'tickets',
}

export const STATUS_PAGE_PATH = {
  PREFIX: 'statuspage',
  INCIDENTS: 'incidents',
  MAINTENANCE: 'maintenance',
  SERVICE_COMPONENTS: 'servicecomponents',
  CUSTOMIZATION: 'customization',
  MANAGE_SUBSCRIBERS: 'manage-subscribers',
  GENERAL: 'general',
  STATUS_EMBED: 'statusembed',
  TEMPLATES: 'templates',
  INCIDENT_SOURCES: 'incident-sources',
  INCIDENT_STATUS: 'incident-status',
}

export const ANALYTICS_PATH = {
  PREFIX: 'analytics',
  OVERVIEW: `overview`,
  INBOX: `inbox`,
  TAGS: `tags`,
  CUSTOMER_SATISFACTION: `customer-satisfaction`,
  METRICS: `metrics`,
  USERS: `users`,
  STAFFING_PREDICTION: `staffing-prediction`,
  AGENT_UTILIZATION: `agent-utilization`,
  SLA: `sla`,
  ARTICLES: `articles`,
  SEARCHES: `searches`,
  TASKS_ANALYTICS: `tasks-analytics`,
  ASSETS_ANALYTICS: `assets-analytics`,
  STATUS_PAGE: `status-page`,
}

export const SETTINGS_PATH = {
  PREFIX: 'settings',
  // My Settings
  MY_PROFILE: `my-profile`,
  // My Organization
  ACCOUNT_SETTINGS: `account-settings`,
  USERS: `users`,
  TEAMS: `teams`,
  ROLES: `roles`,
  NOTIFICATIONS: `notifications`,
  // Channels
  EMAIL: `emails`,
  SUPPORT_WIDGET: `widget`,
  FACEBOOK: `facebook`,
  INSTAGRAM: `instagram`,
  WHATSAPP: `whatsapp`,
  TWITTER: `twitter`,
  CONTACT_FORM: `contact-form`,
  LIVE_CHAT: `chat-inbox`,
  PHONE: `phone`,
  SMS: `sms`,
  // Custom Fields
  CONVERSATIONS: `conversations`,
  CUSTOMERS: `customer`,
  // Automations
  ROUTING: `routing`,
  WORKFLOWS: `workflows`,
  BUSINESS_HOURS: `business-hours`,
  SLA_MANAGEMENT: `sla-management`,
  TIME_TRACKING: `time-tracking`,
  // Productivity
  TAGS: `tags`,
  EMAIL_TEMPLATES: `email-templates`,
  CUSTOMER_SATISFACTION: `customer-satisfaction`,
  CANNED_FORMS: `canned-forms`,
  AUDIT_LOGS: `audit-logs`,
  // Tasks
  TASK_TEMPLATES: `task-templates`,
  TASK_AUTOMATION: `task-automation`,
  // Reports
  SCHEDULE_REPORTS: `schedule-reports`,
  EXPORT: `export`,
  // Billing
  MY_PLAN: `my-plan`,
  INVOICES: `invoices`,
  // Apps
  DEVELOPER_API: `developer-api`,
  INTEGRATIONS: `integrations`,
  SECURITY: `security`,
  CUSTOM_DOMAIN: `custom-domain`,
  // help
  KEYBOARD_SHORTCUTS: `keyboard-shortcuts`,
}

export const SETTINGS_INTEGRATIONS_PATH = {
  SHOPIFY: 'shopify',
  LIVECHAT: 'livechat',
  BIG_COMMERCE: 'bigcommerce',
  JIRA: 'jira',
  GITHUB: 'github',
  ASANA: 'asana',
  CLICKUP: 'clickup',
  TRELLO: 'trello',
  MAGENTO: 'magento',
  SLACK: 'slack',
  INTERCOM: 'intercom',
  DRIFT: 'drift',
}
